import React from 'react';
import { translateResourceString } from '../util/translationUtility';
import { printCurrency, printDate } from '../util/formatUtility';

class InvoiceThankYou extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    switchMyAccountPageToHistoryTab = () => {
        window.$('a[href="#invoiceHistory"]').tab('show');
    };

    render() {
        const {
            selectedAccountOrganizationOption,
            invoicePayment,
            contactUsUrl,
            startPageUrl,
            invoicePaymentType,
            navigateToView
        } = this.props;

        return (
            <div className="invoice-payments--thank-you row">
                <div className="col-lg-8">
                    <h4 className="headline headline-sm mb-4">
                        <i className="fa fa-check-circle mr-2" aria-hidden="true" style={{ color: "green" }}></i>{translateResourceString("/MyAccountPage/InvoicePayments/ThankYou/Header")}
                    </h4>
                    <p className="fw-600" dangerouslySetInnerHTML={
                        {
                            __html: translateResourceString("/MyAccountPage/InvoicePayments/ThankYou/PaymentAuthorizedAndSubmitted", printCurrency(invoicePayment.Total))
                        }}>
                    </p>
                    <p>{translateResourceString("/MyAccountPage/InvoicePayments/ThankYou/TransactionSent", invoicePayment.PayerUserEmail)}</p>
                    <div>
                        <button className="btn btn-cc-red mb-2 mr-2" onClick={this.switchMyAccountPageToHistoryTab}>{translateResourceString("/MyAccountPage/InvoicePayments/ThankYou/ViewHistoryButton")}</button>
                        <button className="btn btn-cc-red mb-2" onClick={() => { navigateToView(0); }}>{translateResourceString("/MyAccountPage/InvoicePayments/ThankYou/MakeAnotherPaymentButton")}</button>
                    </div>
                    <div className="bg-light-gray p-4 my-6">
                        <h5 className="headline headline-xs">{translateResourceString("/MyAccountPage/InvoicePayments/ThankYou/SummaryHeader")}</h5>
                        <dl className="row mb-4 text-sm">
                            <dt className="col-md-6">{translateResourceString("/MyAccountPage/InvoicePayments/ThankYou/CustomerNameLabel")}</dt>
                            <dd className="col-md-6">{selectedAccountOrganizationOption.Name}</dd>
                            <dt className="col-md-6">{translateResourceString("/MyAccountPage/InvoicePayments/ThankYou/CustomerNumberLabel")}</dt>
                            <dd className="col-md-6 mb-4">{selectedAccountOrganizationOption.PayerId}</dd>
                            <dt className="col-md-6">{translateResourceString("/MyAccountPage/InvoicePayments/ThankYou/TransactionDateLabel")}</dt>
                            <dd className="col-md-6">{printDate(invoicePayment.TransactionDate)}</dd>
                            <dt className="col-md-6">{translateResourceString("/MyAccountPage/InvoicePayments/ThankYou/PaymentNumberLabel")}</dt>
                            <dd className="col-md-6">{invoicePayment.InvoicePaymentId}</dd>
                            <dt className="col-md-6">{translateResourceString("/MyAccountPage/InvoicePayments/ThankYou/AmountLabel")}</dt>
                            <dd className="col-md-6">{printCurrency(invoicePayment.InvoicesTotal)}</dd>
                            <dt className="col-md-6">{translateResourceString("/MyAccountPage/InvoicePayments/ThankYou/SurchargeLabel")}</dt>
                            <dd className="col-md-6">{printCurrency(invoicePayment.SurchargeAmount)}</dd>
                            <dt className="col-md-6">{translateResourceString("/MyAccountPage/InvoicePayments/ThankYou/TotalLabel")}</dt>
                            <dd className="col-md-6 mb-4">{printCurrency(invoicePayment.Total)}</dd>
                            {!!invoicePayment.PaymentProcessorGateway && <React.Fragment>
                                <dt className="col-md-6">{translateResourceString("/MyAccountPage/InvoicePayments/ThankYou/PaymentMethodLabel")}</dt>
                                <dd className="col-md-6">{invoicePaymentType}</dd>
                                <dt className="col-md-6">{translateResourceString("/MyAccountPage/InvoicePayments/ThankYou/Last4DigitsLabel")}</dt>
                                <dd className="col-md-6">{invoicePayment.PaymentInstrumentDescription.substr(-4)}</dd>
                            </React.Fragment>}
                        </dl>
                        <p className="text-sm"
                            dangerouslySetInnerHTML={{
                            __html: translateResourceString(
                                "/MyAccountPage/InvoicePayments/ThankYou/OneTimePaymentMessage",
                                `<a href="${contactUsUrl}">${translateResourceString("/MyAccountPage/InvoicePayments/ThankYou/ContactUsLinkText")}</a>`
                            )
                        }}>
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

export default InvoiceThankYou;